@if (items$ | async; as references) {
  @if (references?.length) {
    <cx-carousel [title]="title$ | async" [items]="references" [template]="carouselItem" [itemWidth]="carouselWidth">
    </cx-carousel>
  }
}

<ng-template #carouselItem let-item="item">
  <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: item } | cxUrl">
    <cx-media [container]="item.images?.PRIMARY"></cx-media>
    <h4>{{ item.name }}</h4>
    @if (userPermissionService.showPrice) {
      <div class="price">{{ item.price?.formattedValue }}</div>
    }
  </a>
</ng-template>
